import { forwardRef, memo, useCallback, useState } from "react";
import { TextField, TextFieldProps } from "../TextField";
import { EyeButton } from "./EyeButton";

export type PasswordFieldProps = TextFieldProps & { showEyeIcon?: boolean, }

export const PasswordField = memo(forwardRef<HTMLInputElement, PasswordFieldProps>((
  {
    showEyeIcon = true,
    ...props
  },
  ref,
) => {
  const [ isShownPassword, setIsShownPassword ] = useState(false);

  const onEyeBtnClick = useCallback(
    () => setIsShownPassword(state => !state),
    [ setIsShownPassword ],
  );

  return (
    <TextField
      isClearable={false}
      ref={ref}
      type={isShownPassword ? "text" : "password"}
      endAdornment={
        <>
          {
            showEyeIcon &&
            <EyeButton
              isShownPassword={isShownPassword}
              onClick={onEyeBtnClick}
              disabled={props.disabled}
            />
          }
          {props.endAdornment}
        </>
      }
      {...props}
    />
  );
}));